module.exports = {
  COPY_HANDLERS_REQUEST: 'COPY_HANDLERS_REQUEST',
  COPY_HANDLERS_SUCCESS: 'COPY_HANDLERS_SUCCESS',
  COPY_HANDLERS_FAILURE: 'COPY_HANDLERS_FAILURE',
  EDIT_HANDLERS_REQUEST: 'EDIT_HANDLERS_REQUEST',
  EDIT_HANDLERS_SUCCESS: 'EDIT_HANDLERS_SUCCESS',
  EDIT_HANDLERS_FAILURE: 'EDIT_HANDLERS_FAILURE',
  GET_MRD_BY_COUNTRY_REQUEST: 'GET_MRD_BY_COUNTRY_REQUEST',
  GET_MRD_BY_COUNTRY_SUCCESS: 'GET_MRD_BY_COUNTRY_SUCCESS',
  GET_MRD_BY_COUNTRY_FAILURE: 'GET_MRD_BY_COUNTRY_FAILURE',
  CLEAR_MRD_SELECTION: 'CLEAR_MRD_SELECTION',
  GET_ALL_HANDLERS_REQUEST: 'GET_ALL_HANDLERS_REQUEST',
  GET_ALL_HANDLERS_SUCCESS: 'GET_ALL_HANDLERS_SUCCESS',
  GET_ALL_HANDLERS_FAILURE: 'GET_ALL_HANDLERS_FAILURE',
  GET_HANDLERS_BY_MRD_REQUEST: 'GET_HANDLERS_BY_MRD_REQUEST',
  GET_HANDLERS_BY_MRD_SUCCESS: 'GET_HANDLERS_BY_MRD_SUCCESS',
  GET_HANDLERS_BY_MRD_FAILURE: 'GET_HANDLERS_BY_MRD_FAILURE',
  ASSOCIATE_NEW_HANDLERS_REQUEST: 'ASSOCIATE_NEW_HANDLERS_REQUEST',
  ASSOCIATE_NEW_HANDLERS_SUCCESS: 'ASSOCIATE_NEW_HANDLERS_SUCCESS',
  ASSOCIATE_NEW_HANDLERS_FAILURE: 'ASSOCIATE_NEW_HANDLERS_FAILURE',
  CREATE_NEW_HANDLER_REQUEST: 'CREATE_NEW_HANDLER_REQUEST',
  CREATE_NEW_HANDLER_SUCCESS: 'CREATE_NEW_HANDLER_SUCCESS',
  CREATE_NEW_HANDLER_FAILURE: 'CREATE_NEW_HANDLER_FAILURE',
};
